import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Blockchain">
                <h1>Blockchain Development Company</h1>
              </div>
              <p className="main_para">
                Creating secure, scalable ecosystems through enterprise
                Blockchain solutions
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                We are a Blockchain development services provider to help
                enterprises to acquire transparency and automation in their
                business workflows
              </p>
              <ul>
                <li>Custom Blockchain</li>
                <li>Crypto Token</li>
                <li>Smart Contracts</li>
                <li>Blockchain Security & Consultancy</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
